<template>
  <r-panel :disabled="disabled" :title="title">
    <v-row dense>
      <v-col cols="12" md="4" sm="4">
        <r-currency-kind-dropdown :model.sync="value.currencyFrom" label="Merge Currency"/>
      </v-col>
      <v-col cols="12" sm="2" md="2">
        <v-text-field v-model.number="model.amount" label="Amount" hide-details/>
      </v-col>
      <v-col cols="12" md="4" sm="4">
        <r-currency-kind-dropdown :model.sync="value.currencyTo" label="Ball Currency"/>
      </v-col>
    </v-row>
  </r-panel>
</template>
<script>

import VueTypes from "vue-types";
import {PlinkoExchangeConfig} from "@/modules/redactor/models/smart-offer/bundle-plinko/PlinkoExchangeConfig";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RCurrencyKindDropdown from "@/modules/redactor/views/currency-kind/r-currency-kind-dropdown.vue";

export default {
  name: "r-plinko-exchange-config-panel",
  components: {RCurrencyKindDropdown, RPanel},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Exchange Config"),
    model: VueTypes.instanceOf(PlinkoExchangeConfig),
  },
  computed: {
    value() {
      if (this.model) {
        return this.model;
      } else {
        let value = new PlinkoExchangeConfig();
        this.$emit("update:model", value);
        return value;
      }
    }
  }
}

</script>